import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionService } from '../shared/services';
import { ConfigurationConstants } from '../shared/constants/config';
import { Redirects } from '../shared/constants/redirects';

@Component({
  template: '',
})
export class ChosenWorkspaceRedirectComponent implements OnInit {

  constructor(
    private _router: Router,
    private _sessionService: SessionService
  ) { }

  ngOnInit() {
    const workspaceChoice = this._sessionService.getWorkspaceChoice();
    this._router.navigate([Redirects[workspaceChoice || ConfigurationConstants.START_UP_MENU]]);
  }
}
